<div class="fcp-table-container">
    <fcp-search
        class="fcp-table-search-input"
        *ngIf="showSearch"
        [compact]="true"
        [placeholder]="tableConfig.search.placeholder"
        (searchQueryChange)="onSearchChange($event)"
    ></fcp-search>

    <ng-container *ngIf="rows?.length; else emptyTable">
        <table class="fcp-table" cdk-table [dataSource]="rows">
            <ng-container *ngFor="let column of columns" [cdkColumnDef]="column.id">
                <ng-container *ngIf="column.cellTemplate">
                    <th cdk-header-cell *cdkHeaderCellDef>
                        {{ column.title }}

                        <span cdkOverlayOrigin #tooltip="cdkOverlayOrigin">
                            <fcp-icon
                                *ngIf="column.tooltip"
                                [icon]="column.tooltip.icon"
                                (mouseenter)="tooltipOpen[column.id] = true"
                                (mouseleave)="tooltipOpen[column.id] = false"
                            ></fcp-icon>
                        </span>
                        <fcp-tooltip
                            *ngIf="column.tooltip"
                            [open]="tooltipOpen[column.id]"
                            [overlayOrigin]="tooltip"
                            [customPosition]="tooltipPosition"
                        >
                            {{ column.tooltip.title }}
                        </fcp-tooltip>
                    </th>
                    <td cdk-cell *cdkCellDef="let row" [style]="{ width: column.width }">
                        <div class="td-container">
                            <div class="td-content" [style]="{ width: column.width }">
                                <ng-template
                                    [ngTemplateOutletContext]="{
                                        $implicit: row,
                                        column: column.id
                                    }"
                                    [ngTemplateOutlet]="column.cellTemplate"
                                >
                                </ng-template>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <ng-container *ngIf="!column.cellTemplate">
                    <th cdk-header-cell *cdkHeaderCellDef>{{ column.title }}</th>
                    <td cdk-cell *cdkCellDef="let row" [style]="{ width: column.width }">
                        <div class="td-container">
                            <div class="td-content" [style]="{ width: column.width }" [title]="row[column.id]">
                                {{ row[column.id] }}
                            </div>
                        </div>
                    </td>
                </ng-container>
            </ng-container>

            <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay"></tr>
            <tr cdk-row (click)="onRowClicked(row)" *cdkRowDef="let row; columns: columnsToDisplay"></tr>
        </table>
    </ng-container>

    <ng-template #emptyTable>
        <ng-template *ngIf="rows && emptyTableTemplate" [ngTemplateOutlet]="emptyTableTemplate"></ng-template>
    </ng-template>
</div>
<fcp-load-more
    class="fcp-load-more"
    *ngIf="rows?.length < totalItems"
    [progress]="progress"
    [loadMoreLabel]="tableConfig.loadMore.label"
    [loadMoreButtonLabel]="tableConfig.loadMore.buttonLabel"
    (loadMore)="onLoadMoreClicked()"
></fcp-load-more>
